
import { defineComponent } from "vue";

export default defineComponent({
  props: {},
  setup(props, context) {
    const items = [{ to: "/", title: "Example From Readme" }];
    return {
      items,
    };
  },
});
